import React, { Component } from "react";
import * as s from "./SearchFilter.module.scss";
import { inject, observer } from "mobx-react";
import { toJS } from "mobx";
import { FilterStore, SearchStore, UIStore } from "src/stores";
import {
  NonHierarchicalDropdown,
  HierarchicalDropdown,
  DateRangeDropdown,
  SingleSelectDropdown,
  Button,
  SelectedTaxonomiesList
} from "src/views/shared/components";
import { tx } from "src/libs/i18n";

interface Props {
  filterStore?: FilterStore;
  searchStore?: SearchStore;
  uiStore?: UIStore;
}

@inject("filterStore", "searchStore", "uiStore")
@observer
export class SearchFilter extends Component<Props> {
  render() {
    const { filterStore, uiStore, searchStore } = this.props;
    const {
      toggleOption,
      toggleYear,
      prioritize,
      publicationYears,
      authors,
      topics,
      keywords,
      countries,
      regions,
      publishers,
      contentTypes,
      userChallenges,
      targetAudiences,
      sortResultsOptions,
      setSortOption,
      languages,
      resetFilterAndSearch,
    } = filterStore;
    const { isDesktop } = uiStore;
    const { getDocuments } = searchStore;
    return (
      <div className={s.searchFilterColumn}>
        <h3 className={s.filterColTitle}>{tx("filter.refineResults")}</h3>
        <SelectedTaxonomiesList />
        {isDesktop && (
          <Button
            size="medium"
            color="red"
            className={s.filterButtons}
            onClick={() => getDocuments(null, true)}
          >
            {tx("filter.applyFilter")}
          </Button>
        )}
        {!isDesktop && (
          <div className={s.sortResultsDropdownContainer}>
            <SingleSelectDropdown
              options={sortResultsOptions}
              toggleOption={setSortOption}
              label={`${tx("filter.sortBy")}:`}
            />
          </div>
        )}
        <Button
          size="medium"
          color="red"
          className={s.filterButtons}
          onClick={() => resetFilterAndSearch()}
        >
          {tx("filter.resetFilter")}
        </Button>
        <NonHierarchicalDropdown
          dropdownTitle={tx("filter.prioritize")}
          largeOptions
          options={prioritize}
          toggleOption={toggleOption}
          className={s.filterDropdown}
          key={"nonHierarchicalDropdown-prioritize"}
        />
        <hr className={s.filterDivider} key={"first-line"} />
        <DateRangeDropdown
          dropdownTitle={tx("filter.publicationYear")}
          toggleYear={toggleYear}
          selectedOptions={publicationYears}
        />
        <hr className={s.filterDivider} key={"second-line"} />
        <HierarchicalDropdown
          dropdownTitle={tx("filter.topics")}
          options={topics}
          toggleOption={toggleOption}
          className={s.filterDropdown}
        />
        {authors &&
          authors.length > 0 && [
            <hr className={s.filterDivider} key={"third-line"} />,
            <NonHierarchicalDropdown
              dropdownTitle={tx("filter.authors")}
              options={authors}
              toggleOption={toggleOption}
              className={s.filterDropdown}
              search
              key={"nonHierarchicalDropdown-authors"}
            />,
          ]}
        {publishers &&
          publishers.length > 0 && [
            <hr className={s.filterDivider} key={"fourth-line"} />,
            <NonHierarchicalDropdown
              dropdownTitle={tx("filter.publisher")}
              options={publishers}
              toggleOption={toggleOption}
              className={s.filterDropdown}
              search
              key={"nonHierarchicalDropdown-publisher"}
            />,
          ]}
        {contentTypes &&
          contentTypes.length > 0 && [
            <hr className={s.filterDivider} key={"fifth-line"} />,
            <NonHierarchicalDropdown
              dropdownTitle={tx("filter.contentType")}
              options={contentTypes}
              toggleOption={toggleOption}
              className={s.filterDropdown}
              search
              key={"nonHierarchicalDropdown-contentType"}
            />,
          ]}
        {countries &&
          countries.length > 0 && [
            <hr className={s.filterDivider} key={"sixth-line"} />,
            <NonHierarchicalDropdown
              dropdownTitle={tx("filter.country")}
              options={countries}
              toggleOption={toggleOption}
              className={s.filterDropdown}
              search
              key={"nonHierarchicalDropdown-country"}
            />,
          ]}
        {regions &&
          regions.length > 0 && [
            <hr className={s.filterDivider} key={"seventh-line"} />,
            <NonHierarchicalDropdown
              dropdownTitle={tx("filter.regions")}
              options={regions}
              toggleOption={toggleOption}
              className={s.filterDropdown}
              search
              key={"nonHierarchicalDropdown-regions"}
            />,
          ]}
        {languages &&
          languages.length > 0 && [
            <hr className={s.filterDivider} key={"eigth-line"} />,
            <NonHierarchicalDropdown
              dropdownTitle={tx("filter.language")}
              options={languages}
              toggleOption={toggleOption}
              className={s.filterDropdown}
              search
            />,
          ]}
        {keywords &&
          keywords.length > 0 && [
            <hr className={s.filterDivider} key={"nineth-line"} />,
            <NonHierarchicalDropdown
              dropdownTitle={tx("filter.keywords")}
              options={keywords}
              toggleOption={toggleOption}
              className={s.filterDropdown}
              search
              key={"nonHierarchicalDropdown-keywords"}
            />,
          ]}
        {userChallenges &&
          userChallenges.length > 0 && [
            <hr className={s.filterDivider} key={"tenth-line"} />,
            <NonHierarchicalDropdown
              dropdownTitle={tx("filter.userChallenges")}
              options={userChallenges}
              toggleOption={toggleOption}
              className={s.filterDropdown}
              search
              key={"nonHierarchicalDropdown-userChallenge"}
            />,
          ]}
        {targetAudiences &&
          targetAudiences.length > 0 && [
            <hr className={s.filterDivider} key={"eleventh-line"} />,
            <NonHierarchicalDropdown
              dropdownTitle={tx("filter.targetAudiences")}
              options={targetAudiences}
              toggleOption={toggleOption}
              className={s.filterDropdown}
              search
              key={"nonHierarchicalDropdown-targetAudience"}
            />,
          ]}
      </div>
    );
  }
}
